import React, { useMemo } from 'react';

import { BaseButton, btnSizes, btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';

import { BlindMenu } from '../index';

import * as ST from './styled';

export interface IElemData {
    id: string,
    text: string,
    link?: string,
    onClick?: () => void,
}

interface IProps {
    isMobileView: boolean,
    elements: IElemData[],
    btnText?: string,
    Button?: JSX.Element,
    blindMenuRef?: React.RefObject<HTMLDivElement>,
    onElementClick?: (id: string) => void,
    displayDropDown?: boolean,
    [key: string]: unknown,
}

export const BlindMenuWithBtn = ({
    btnText = 'Меню',
    Button,
    isMobileView,
    elements,
    displayDropDown,
    blindMenuRef,
    onElementClick,
    ...rest
}: IProps): JSX.Element => {

    const elementClickHandler = (el: IElemData) => {
        if (typeof onElementClick === 'function') {
            onElementClick(el.id);
        } else if (typeof el.onClick === 'function') {
            el.onClick();
        }
    };

    const activeComponent = useMemo(
        () => Button || <DefaultButton btnText={btnText}/>,
        [Button, btnText],
    );

    return (
        <BlindMenu
            activeComponent={activeComponent}
            displayDropDown={displayDropDown}
            isMobileView={isMobileView}
            blindMenuRef={blindMenuRef}
            {...rest}
        >
            {elements.map(el => (
                <ST.Button
                    key={el.id}
                    isMobileView={isMobileView}
                    type={isMobileView ? btnTypes.SECONDARY : btnTypes.GHOST}
                    size={btnSizes.SMALL}
                    href={el.link}
                    onClick={() => elementClickHandler(el)}
                >
                    {el.text}
                </ST.Button>
            ))}
        </BlindMenu>
    );
};

const DefaultButton = ({ btnText }: Pick<IProps, 'btnText'>) => <BaseButton size={btnSizes.SMALL} type={btnTypes.SECONDARY} text={btnText}/>;
